
export {} from '@clayui/sticker';
import __x__ from '@clayui/sticker';export default __x__;